module.exports = __webpack_public_path__ + "img/material_selection@2x.f69dd0f.webp";